<div class="accordion bg-white pb-1" id="accordion">
	@for (groupItem of groups; track groupItem) {
		<div [id]="elementNavigationId('custom-panel-', groupItem.id)" class="card mb-3 border-0 mb-3">
			<div
				class="card-header cursor-pointer py-0 border"
				(click)="groupItemClicked(groupItem)"
				role="link"
				[attr.aria-expanded]="!isCollapsed(groupItem.id)"
				[attr.aria-controls]="elementNavigationId('collapse-panel-', groupItem.id)"
				[ngClass]="selectedGroupItemId === groupItem.id ? 'bg-primary border-primary' : ''">
				<div class="d-flex justify-content-between align-items-center">
					<!-- ICON -->
					<div>
						@if (groupItem.logo !== '' && groupItem.logo !== null) {
							<img
								[src]="groupItem.logo"
								loading="lazy"
								style="height: 50px; width: 50px"
								[alt]="groupItem.titleResourceKey | translate"
								class="item-header-image" />
						}
					</div>
					<!-- Title -->
					<div class="w-100 text-center">
						<div class="item-header-title">
							{{ groupItem.titleResourceKey | translate }}
						</div>
					</div>
					<!-- Chevron up/down-->
					<div class="nav-width">
						@if (groupItem.items.length > 1) {
							<div
								[ngClass]="isCollapsed(groupItem.id) ? 'keyboard-arrowdown-mask-img' : 'keyboard-arrowup-mask-img'"
								class="enabled chevron mask-settings bg-dark cursor-pointer accordion-icon"
								style="height: 1.8rem; width: 1.8rem"></div>
						}
					</div>
				</div>
			</div>
			<div
				class="card-body p-0"
				[id]="elementNavigationId('collapse-panel-', groupItem.id)"
				[ngbCollapse]="isCollapsed(groupItem.id)"
				[ngClass]="{
					collapsed: isCollapsed(groupItem.id),
				}">
				<!-- Folgende class mit "p-0 m-0" machen den leeren Bereich kleiner, bitte so lassen!!! -->
				<!-- Für eine Animation müsste ein m-4 gesetzt werden als Ersatz für den zurückgesetzten p-0 im card-body. Bitte prüfen. -->
				<div class="ms-1">
					@if (groupItem.items.length > 1) {
						<ul class="p-0 mt-3 ms-2 mb-0" [attr.aria-description]="'categorygroup with id ' + groupItem.id">
							@for (item of groupItem.items; track item) {
								<li
									[attr.aria-description]="'category with id ' + item.id"
									(click)="itemClicked(groupItem, item)"
									class="cursor-pointer p-1"
									[ngClass]="{
										'bg-primary': selectedItemId === item.id,
									}">
									{{ item.titleResourceKey | translate }}
								</li>
							}
						</ul>
					}
				</div>
			</div>
		</div>
	}
</div>
